export const INITIAL_VERSION = 0;
export const INITIAL_TOTAL_VERSIONS = 1;
